
































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IContractCancellationRequest,
  IContractProduct
} from "@/models/contracts";
import { mapGetters } from "vuex";
import { DataModules } from "@/store/modules/data";
import AdminBrands from "@/mixins/adminBrands";

@Component({
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  },
  components: {
    "cprod-status-summary": () =>
      import("@/components/app/global/contractProducts/cProdStatusSummary.vue")
  }
})
export default class ContractCancellationRequestsTableRow extends Mixins(
  AdminBrands
) {
  @Prop({ required: true })
  public contractCancellationRequest!: IContractCancellationRequest;

  public isMultibrand!: boolean;

  // Data
  public isApproving = false;
  public isRejecting = false;

  public get contractProduct(): IContractProduct {
    if (this.$_.isEmpty(this.contractCancellationRequest.product_ids)) {
      return {} as IContractProduct;
    }
    return this.$_.find(this.contract.products, [
      "id",
      this.contractCancellationRequest.product_ids[0]
    ]) as IContractProduct;
  }

  public get hasContractProduct() {
    return !this.$_.isEmpty(this.contractProduct);
  }

  public get isProcessing() {
    return this.isRejecting || this.isApproving;
  }

  public get client() {
    return this.$_.get(this.contractCancellationRequest, "contract.client");
  }

  public get contract() {
    return this.$_.get(this.contractCancellationRequest, "contract");
  }

  public get reason() {
    return this.$_.get(this.contractCancellationRequest, "reason", "")
      .trim()
      .replace(/[^a-zA-Z\d]$/, "");
  }

  // Methods
  public openAdminCancellationModal() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS}/openAdminCancellationModal`,
      {
        props: {
          contractProductId: this.contractProduct.id,
          contractId: this.contract.id
        },
        events: {
          "contract-updated": () => this.$emit("request-updated")
        }
      }
    );
  }
}
